import { render, staticRenderFns } from "./panel-2.vue?vue&type=template&id=33ba3418&scoped=true"
import script from "./panel-2.vue?vue&type=script&lang=js"
export * from "./panel-2.vue?vue&type=script&lang=js"
import style0 from "./panel-2.vue?vue&type=style&index=0&id=33ba3418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba3418",
  null
  
)

export default component.exports